import { StyleSheet } from 'react-native-unistyles';
import type { UnistylesThemes } from 'react-native-unistyles';

import { configure as configureUnistyles } from '@squire/ui/configure';
import { theme } from '@squire/ui/theme';

import { config } from '@/constants/config';

configureUnistyles({
  allowFontScaling: false,
  settings: {
    // Dark mode is not supported yet. Seeding from `UnistylesRuntime.colorScheme`
    // booted the app dark for a frame on a dark device before `_layout` pinned
    // light. Restore the colorScheme read when dark mode ships.
    initialTheme: 'light',
  },
  themes: config.colors,
  breakpoints: theme.breakpoints,
});

StyleSheet.configure({
  // Project colors extend the lib defaults at runtime via configureUnistyles above
  themes: config.colors as unknown as UnistylesThemes,
  breakpoints: theme.breakpoints,
  settings: {
    // Dark mode is not supported yet. Seeding from `UnistylesRuntime.colorScheme`
    // booted the app dark for a frame on a dark device before `_layout` pinned
    // light. Restore the colorScheme read when dark mode ships.
    initialTheme: 'light',
  },
});
